import { cn, dynamicStyling } from 'styles';

import { useTable } from '../Table';
import TableRow from '../Row';

import TableActions from './Actions';

import { tableStyleConfig } from '../styles';

function TableHeader() {
  const { columns, headerClassName: globalHeadClassName, cellClassName, spacing } = useTable();

  return (
    <thead>
      <TableRow>
        {columns.map((column, columnIndex) => (
          <th
            key={
              typeof column.label === 'string'
                ? column.label
                : `header-config-${column.id || column.property || columnIndex}`
            }
            colSpan={column.columnSpan}
            {...dynamicStyling({
              width: column.width,

              className: cn(
                'whitespace-nowrap text-start align-middle font-medium text-muted-foreground',
                tableStyleConfig.spacing[spacing],
                cellClassName,
                globalHeadClassName,
                column.className,
                column.headerClassName,
              ),
            })}
          >
            {column.label ?? ' '}

            <TableActions column={column} index={columnIndex} />
          </th>
        ))}
      </TableRow>
    </thead>
  );
}

export default TableHeader;
